module.exports = __webpack_public_path__ + "img/soja.2250628d.png";